"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.formatUrl = formatUrl;
exports.linkify = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _linkifyIt = _interopRequireDefault(require("linkify-it"));
var _escapeHtml = _interopRequireDefault(require("escape-html"));
var _escapeStringRegexp = _interopRequireDefault(require("escape-string-regexp"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var linkify = exports.linkify = (0, _linkifyIt["default"])().tlds(require('tlds')).set({
  fuzzyEmail: false
});
function replaceAll(str, mapObj) {
  var re = new RegExp(Object.keys(mapObj).map(function (item) {
    return (0, _escapeStringRegexp["default"])(item);
  }).join('|'), 'gi');
  return str.replace(re, function (matched) {
    return mapObj[matched];
  });
}
var _default = exports["default"] = function _default(rootElement) {
  var textWalker = rootElement.ownerDocument.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT);
  var nodes = [];
  while (textWalker.nextNode()) {
    var node = textWalker.currentNode;
    var content = node.textContent;
    if (node.parentElement) {
      var withinScript = node.parentElement.tagName === 'SCRIPT';
      var withinStyle = node.parentElement.tagName === 'STYLE';
      var withinA = node.parentElement.closest('a') !== null;
      if (withinScript || withinA || withinStyle) {
        continue;
      }
    }
    if (node.textContent.trim().length < 4) {
      continue;
    }
    var matches = linkify.match(content);
    if (matches) {
      var newInnerHTML = replaceAll(content, matches.reduce(function (prev, curr) {
        return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2["default"])({}, curr.text, "<a href=\"".concat(curr.url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat((0, _escapeHtml["default"])(curr.text), "</a>")));
      }, {}));
      nodes.push({
        node: node,
        html: newInnerHTML
      });
    }
  }
  nodes.forEach(function (_ref) {
    var node = _ref.node,
      html = _ref.html;
    var txt = document.createElement('span');
    txt.innerHTML = html;
    node.replaceWith(txt);
  });
};
function isEncoded(uri) {
  uri = uri || '';
  try {
    return uri !== decodeURIComponent(uri);
  } catch (e) {
    return false;
  }
}
function formatUrl(url) {
  url = isEncoded(url) ? url : encodeURI(url);
  var matchResult = linkify.match(url);
  if (matchResult && matchResult.length === 1 && matchResult[0].index === 0 && matchResult[0].lastIndex === url.length) {
    var _matchResult$ = matchResult[0],
      schema = _matchResult$.schema,
      targetUrl = _matchResult$.url;
    if (!schema) return "//".concat(url);
    return targetUrl;
  }
  throw Error('invalid url');
}
//# sourceMappingURL=autolinker.js.map